import React, {useMemo} from 'react'
import {
    Box,
    Text,
    Grid,
    GridItem,
    Tooltip as ChakraUITooltip,
    IconButton,

    /* Hooks */
    useMultiStyleConfig
} from '@chakra-ui/react'
import PropTypes from 'prop-types'

/* Utils */
import {renderComponentsSwitch} from '../../utils/contentRenderer'
import {generateStyles, getHideStyles} from '../../utils/utils'
import {calculateGridImageSizes, calculateGridImageWidths} from '../../../../utils/image-cdn-utils'

/* Icons */
import {InfoCircle} from '../../../icons'

const WidgetGridBlock = ({
    ContainerTitle,
    TileDisplayMode,
    TileList,
    WidgetGridBlockTitleStyle,
    Tooltip,
    WidgetGridBlockTooltipStyle,
    HideOnDevices
}) => {
    const gridSize = TileList?.length || 1

    const styles = useMultiStyleConfig('WidgetGridBlock', {
        TileDisplayMode,
        GridSize: gridSize
    })

    const global = useMultiStyleConfig('GlobalCMS')

    // Calculate responsive image sizes based on grid columns
    const imageSizes = useMemo(() => {
        return calculateGridImageSizes({
            mobileColumns: 1,
            tabletColumns: Math.min(gridSize, 2), // Max 2 columns on tablet
            desktopColumns: gridSize,
            gap: 16
        })
    }, [gridSize])

    // Calculate appropriate image widths for this grid
    const imageWidths = useMemo(() => {
        return calculateGridImageWidths(gridSize)
    }, [gridSize])

    const hideStyles = getHideStyles(HideOnDevices)

    if (hideStyles.doNotLoadComponent) return

    return (
        <Box
            {...global.lgContainer}
            {...styles.container}
            {...hideStyles}
            data-block-type="WidgetGridBlock"
        >
            {ContainerTitle && (
                <Box>
                    <Text
                        {...generateStyles(
                            WidgetGridBlockTitleStyle,
                            {...styles.WidgetGridBlockTitleStyle},
                            {h1: '16px'}
                        )}
                    >
                        {ContainerTitle}
                    </Text>
                </Box>
            )}
            <Box {...styles.wrapper}>
                {Tooltip && Tooltip !== '' && (
                    <ChakraUITooltip
                        closeOnClick={false}
                        label={Tooltip}
                        placement="bottom-end"
                        {...generateStyles(WidgetGridBlockTooltipStyle, {...global.tooltip})}
                    >
                        <IconButton {...global.tooltipIcon} icon={<InfoCircle />}></IconButton>
                    </ChakraUITooltip>
                )}
                {TileList?.length > 0 && (
                    <Grid {...styles?.grid}>
                        {TileList?.map((tile, index) => {
                            return (
                                <GridItem key={`WidgetGridBlock-${tile?.ContentLink?.id}-${index}`}>
                                    {renderComponentsSwitch(tile?.ContentLink?.Expanded, {
                                        widths: imageWidths,
                                        sizes: imageSizes,
                                        preset: 'TILE'
                                    })}
                                </GridItem>
                            )
                        })}
                    </Grid>
                )}
            </Box>
        </Box>
    )
}

WidgetGridBlock.propTypes = {
    ContainerTitle: PropTypes.string,
    TileDisplayMode: PropTypes.string,
    TileList: PropTypes.array,
    WidgetGridBlockTitleStyle: PropTypes.object,
    Tooltip: PropTypes.string,
    WidgetGridBlockTooltipStyle: PropTypes.object,
    HideOnDevices: PropTypes.array
}

export default WidgetGridBlock
